import { useState } from 'react';

import GenericPropertyInput from '../../../FlowDesigner/Components/Inputs/GenericPropertyInput';
import ColorInputContent from './ColorInputContent';
import { ColorInputDialog } from './ColorInputDialog';

type ColorInputProps = {
	color: string | undefined;
	onColorChange: (color: string | undefined) => void;
};

export default function ColorInput({ color, onColorChange }: ColorInputProps) {
	const [open, setOpen] = useState(false);

	return (
		<GenericPropertyInput value={color} onValueChange={onColorChange} onOpen={() => setOpen(true)}>
			<ColorInputContent value={color} />
			{open && <ColorInputDialog open={open} setOpen={setOpen} color={color} onColorChange={onColorChange} />}
		</GenericPropertyInput>
	);
}
